import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=4f642a8c&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmationModal.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmationModal.vue?vue&type=style&index=0&id=4f642a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f642a8c",
  null
  
)

export default component.exports